import React, { useMemo, useState } from "react";
import './Diagram.css';

interface IDiagramProps{
    points: Array<{
        value: number;
        label: string;
    }>;
    activeIndex: number
}

export const Diagram = ({points, activeIndex}: IDiagramProps)=>{
    const [hover, setHover] = useState(-1);
    const max = useMemo(()=>{
        return points.reduce((ac, it)=>{
            return Math.max(ac, it.value);
        }, 0);
    }, [points]);

    const getBarHeight = (value: number) => {
        if (max === 0) return 0;
        // Use absolute pixel height instead of percentage for more reliable scaling
        // The diagram container is 150px height, leaving space for labels
        const availableHeight = 120; // pixels available for bars
        return (value / max) * availableHeight;
    };

    return <div className={`diagram`}
        onMouseLeave={()=>{
            setHover(-1);
        }}
    >
        {points.map((point, index)=>{
            return <div className={`diagram_point_sizer ${(activeIndex == index && (hover == -1  || hover == index) || hover == index) ? 'diagram_point_sizer--active':''} ${index > activeIndex ? 'diagram_point_sizer--gray':''}`}>
                <div className={`diagram_point`}
                    onMouseEnter={()=>{
                        setHover(index);
                    }}
                    onMouseLeave={()=>{
                        //setHover(-1);
                    }}
                >
                    <div className="diagram_point_value">
                        {point.value}
                    </div>
                    <div className="diagram_point_column" style={{height: `${getBarHeight(point.value)}px`}}>

                    </div>
                    <div className="diagram_point_label">
                        {point.label}
                    </div>
                </div>
            </div>
        })}
    </div>
}